import { Notifier } from "@airbrake/browser";

// https://simplybusiness.airbrake.io/projects/512949/edit#tab-access
// This configuration is for embedded-qcp project
const defaultProjectId = 512949;
const defaultProjectKey = "4e25197d8faea61c10fbb97702200780";

// Map of project IDs to notifier instances to support multiple Airbrake accounts
const notifierInstances = new Map<number, Notifier>();

// Fake notifier which logs to console instead of sending to Airbrake
const fakeAirbrake = {
  notify:
    globalThis.process?.env?.NODE_ENV === "test"
      ? () => {}
      : console.error.bind(console),
};

// Get Airbrake environment from AIRBRAKE_ENV, defaulting to "development"
export const getAirbrakeEnvironment = () =>
  globalThis.process?.env?.AIRBRAKE_ENV ?? "development";

// Only send real alerts in staging and production environments
const shouldUseAirbrake = () => {
  const env = getAirbrakeEnvironment();
  return env === "staging" || env === "production";
};

export type GetAirbrakeOptions = {
  projectId?: number;
  projectKey?: string;
  forceSend?: boolean;
};

export function getAirbrake(options: GetAirbrakeOptions = {}) {
  const {
    projectId = defaultProjectId,
    projectKey = defaultProjectKey,
    forceSend,
  } = options;

  if (!forceSend && !shouldUseAirbrake()) {
    return fakeAirbrake;
  }

  let notifierInstance = notifierInstances.get(projectId);

  if (!notifierInstance) {
    notifierInstance = new Notifier({
      projectId,
      projectKey,
      environment: getAirbrakeEnvironment(),
      instrumentation: {
        onerror: false,
        unhandledrejection: false,
      },
    });
    notifierInstances.set(projectId, notifierInstance);
  }

  return notifierInstance;
}
